"use client"

import { PropsWithChildren, useLayoutEffect } from 'react'

export default function NoChrome({ children }: PropsWithChildren) {
  useLayoutEffect(() => {
    if (typeof document !== 'undefined') {
      document.body.classList.add('no-chrome')
      return () => {
        document.body.classList.remove('no-chrome')
      }
    }
  }, [])
  return <>{children}</>
}
